import { useContext, createContext, useState } from "react";

const animeChoices = [
  {name: 'confetti', url: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExM2pxZTFocm9xOW10cmV4N3c0Zm8zZG9xejZnaXV0bzBwMWM1cDY4NiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/PotiYSwEnO33KX007a/giphy.gif" },
  {name: 'coins', url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNmRnMXVoNTdxdHM4Ynl3emd4dWFoZTJ4c2EyemZpc2UydHd1enZkbyZlcD12MV9zdGlja2Vyc19zZWFyY2gmY3Q9cw/NsAXBSpx0MJ6IBDCPY/giphy.gif"},
  {name: 'stars_colors', url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNnJzcndta2lrMzExc2Fjdmozcjl1Y2txd3puN2U0Yno4cXpjOTV4cyZlcD12MV9zdGlja2Vyc19zZWFyY2gmY3Q9cw/2A4BkdUuBFvtuIlKU7/giphy.gif"},
  {name: 'stars_yellow', url: "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExdGdqNW9oc3J1NDAwNzFkMzB5NTdpeTJ4NzFqY3ZnZm9uNzU2a2R6dyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/tHJssvGFi90ILDOJwO/giphy.gif"},
  {name: 'fire_works', url: "https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3OWd1eG5qM2JleDRwM2JneTZobXo3Y2RiN3c3aWpqaHNueGQ5eHp5ayZlcD12MV9zdGlja2Vyc19zZWFyY2gmY3Q9cw/8fftcK2D4PK6XCs2P0/giphy.gif"},
  {name: 'rockets', url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExeTcweTFxa24ycjBlc2tkcjE1eWVibmV5dXlkc3dmMXZ1Z2o2eWRwbSZlcD12MV9zdGlja2Vyc19zZWFyY2gmY3Q9cw/RMYD1TaLfC8d65O1i9/giphy.gif"},
  {name: 'music', url: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExdTdqcWx1NWV3a29kbnRqYmFvcmE1cXp1MGVzNDQwazhnYWNtbDFsbSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/vewRJUpGz1WTWlzz8f/giphy.gif"},
  {name: 'hearts', url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdnBmMjR3djJ0azh3MG94a3VsMHhjd2wwNm11Y2E4ZHZvYjllbWFzbyZlcD12MV9zdGlja2Vyc19zZWFyY2gmY3Q9cw/Y3HTF8WdRpEFIu3FA8/giphy.gif"}
]

const AnimeContext = createContext();

const AnimeProvider = ({ children }) => {
	const [anime, setAnime] = useState('');
	
  const handleTriggerAnime = () => {
      const i = Math.floor(Math.random() * animeChoices.length);
      setAnime(animeChoices[i])
      setTimeout(() => {     
        setAnime('')
      }, 2000);
  };

  return <AnimeContext.Provider value={{anime, handleTriggerAnime}}>{children}</AnimeContext.Provider>;
};

export default AnimeProvider;

export const useAnime = () => {
  return useContext(AnimeContext);
};